/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import {
  MANDATE_EXCLUSIVE_RENTAL_MANAGEMENT,
  MANDATE_EXCLUSIVE_SALE,
  MANDATE_SEARCH,
  MANDATE_SEASONAL_RENTAL,
  MANDATE_SIMPLE_RENTAL,
  MANDATE_SIMPLE_SALE
} from '../../enums/MandateTypes.mjs'
import { ComboboxItem } from '@mantine/core'

function useMandateTypeOptions (empty = false): ComboboxItem[] {
  const intl = useIntl()
  return useMemo(() => [
    {
      value: '',
      label: ''
    },
    {
      value: MANDATE_SEARCH,
      label: intl.formatMessage({
        id: 'search_mandate',
        defaultMessage: 'Recherche'
      })
    },
    {
      value: MANDATE_SEASONAL_RENTAL,
      label: intl.formatMessage({
        id: 'seasonal_rental_mandate',
        defaultMessage: 'Location saisonnière'
      })
    },
    {
      value: MANDATE_EXCLUSIVE_RENTAL_MANAGEMENT,
      label: intl.formatMessage({
        id: 'exclusive_rental_management_mandate',
        defaultMessage: 'Gestion locative exclusive'
      })
    },
    {
      value: MANDATE_SIMPLE_RENTAL,
      label: intl.formatMessage({
        id: 'simple_rental_mandate',
        defaultMessage: 'Location simple'
      })
    },
    {
      value: MANDATE_EXCLUSIVE_SALE,
      label: intl.formatMessage({
        id: 'exclusive_sale_mandate',
        defaultMessage: 'Vente exclusive'
      })
    },
    {
      value: MANDATE_SIMPLE_SALE,
      label: intl.formatMessage({
        id: 'simple_sale_mandate',
        defaultMessage: 'Vente simple'
      })
    }
  ].filter((el) => empty || el.value !== ''), [empty, intl])
}

export default useMandateTypeOptions
